import { Grid2 } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { DEVICES, HOSPITAL_CONNECTIONS } from '@constants/routes';

import { useEnv } from '@hooks/useEnv';

import AddingButton from '../AddingButton';
import { DashHeader } from '../Common.style';

const messages = defineMessages({
  addDevice: {
    id: 'healthAndStreaks.addDevice',
    defaultMessage: 'Add Health Device',
  },
  addHospitals: {
    id: 'healthAndStreaks.addHospitals',
    defaultMessage: 'Add Hospitals',
  },
});

function HealthAndStreaks() {
  const { formatMessage } = useIntl();
  const { isProduction } = useEnv();
  const { palette } = useTheme();

  return (
    <>
      <DashHeader />
      <Grid2 container>
        <Grid2 size={{ xs: isProduction ? 12 : 6 }}>
          <AddingButton
            circle
            color={palette.purple.main}
            iconName={[{ name: 'watch-fitness', color: 'purple.contrastText' }]}
            onClick={() => {
              navigate(DEVICES);
            }}
            text={formatMessage(messages.addDevice)}
          />
        </Grid2>
        {!isProduction && (
          <Grid2 size={{ xs: 6 }}>
            <AddingButton
              circle
              color={palette.teal.main}
              iconName={[{ name: 'hospital', color: 'purple.contrastText' }]}
              onClick={() => {
                navigate(HOSPITAL_CONNECTIONS);
              }}
              text={formatMessage(messages.addHospitals)}
            />
          </Grid2>
        )}
      </Grid2>
    </>
  );
}

export default HealthAndStreaks;
